import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollCSSTEarningsSetup } from "../../components/PayrollCSSTEarningsSetup";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";
import { PayrollInsurableEarningsSetup } from "../../components/PayrollInsurableEarningsSetup";
import { PayrollPensionableEarningsSetup } from "../../components/PayrollPensionableEarningsSetup/PayrollPensionableEarningsSetup";

export const PayrollCSSTEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll CSST Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll CSST Earnings", navigateTo: "/company/payrollCSSTEarnings/setup" }
      ]}
      mainContents={<PayrollCSSTEarningsSetup />}
    />
  );
};
